import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import { MemberMenuAccessRole, MemberStatus } from "~~/package/mapper/organization/model/OrganizationMemeberTypes";
import { UserV2Type } from "~~/package/mapper/user/model/UserType";
import {UserStatusType} from '~~/package/mapper/user/model/UserStatusType';

export class OrganizationMemberModel extends Model {
  constructor(
      public userUuid: string = "",
      public profileImageUrl: string = "",
      public fullName: string = "",
      public email: string = "",
      public menuAccessRoles: MemberMenuAccessRole[] = [],
      public organizationRole: UserV2Type = UserV2Type.ORG_MEMBER,
      public status: MemberStatus = MemberStatus.DECLINED,
      public lastLoginAt: string = "",
      public userStatus: UserStatusType = UserStatusType.NORMAL,

      public memberActionPopup: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<OrganizationMemberModel>): OrganizationMemberModel {
    return createModel<OrganizationMemberModel>(OrganizationMemberModel, {
      ...model
    });
  }
}
